import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'Task No',
     label: 'Task No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'taskTypeName',
     field: FIELDS.TASK_TYPE_NAME,
     title: 'Type',
     label: 'Type',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taskStatusName',
     field: FIELDS.TASK_STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taskPriorityName',
     field: FIELDS.TASK_PRIORITY_NAME,
     title: 'Priority',
     label: 'Priority',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'accountType',
     field: FIELDS.ACCOUNT_TYPE,
     title: 'Account',
     label: 'Account',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'mainPhone',
     field: FIELDS.MAIN_PHONE,
     title: 'Main Phone',
     label: 'Main Phone',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'fullAddress',
     field: FIELDS.FULL_ADDRESS,
     title: 'Address',
     label: 'Address',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contactFirstName',
     field: FIELDS.CONTACT_FIRST_NAME,
     title: 'Contact First Name',
     label: 'Contact First Name',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactLastName',
     field: FIELDS.CONTACT_LAST_NAME,
     title: 'Contact Last Name',
     label: 'Contact Last Name',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Contact Email',
     label: 'Contact Email',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'directPhone',
     field: FIELDS.DIRECT_PHONE,
     title: 'Direct Phone',
     label: 'Direct Phone',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'cellPhone',
     field: FIELDS.CELL_PHONE,
     title: 'Cell Phone',
     label: 'Cell Phone',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'assignedToUserFullName',
     field: FIELDS.ASSIGNED_TO_USER_FULL_NAME,
     title: 'Assigned To',
     label: 'Assigned To',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taskDue',
     field: FIELDS.TASK_DUE,
     title: 'Task Due',
     label: 'Task Due',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'aging',
     field: FIELDS.AGING,
     title: 'Aging',
     label: 'Aging',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subject',
     field: FIELDS.SUBJECT,
     title: 'Subject',
     label: 'Subject',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'notes',
     field: FIELDS.NOTES,
     title: 'Notes',
     label: 'Notes',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     sortable: true,
     hidden: false,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
